import { ArrowRight, BadgeCheck, Factory, PackageCheck, Wrench } from "lucide-react";
import { Link } from "react-router-dom";

export function HomePage() {
  return (
    <>
      <section className="hero">
        <div className="hero-copy">
          <span className="eyebrow">Indústria automotiva brasileira</span>
          <h1>Peças confiáveis para manter o Brasil em movimento.</h1>
          <p>Consulte nossa linha de produtos, envie seus pedidos e acompanhe cada etapa da produção em um único lugar.</p>
          <div className="hero-actions">
            <Link className="button primary" to="/catalogo">Ver produtos <ArrowRight size={18} /></Link>
            <Link className="button secondary" to="/cadastro">Criar cadastro</Link>
          </div>
        </div>
        <div className="hero-panel" aria-label="Destaques Holyman">
          <div className="hero-line"><Factory /><span><strong>Produção acompanhada</strong><small>Da aprovação até a expedição</small></span></div>
          <div className="hero-line"><Wrench /><span><strong>Aplicação automotiva</strong><small>Busca por nome, SKU ou código legado</small></span></div>
          <div className="hero-line"><PackageCheck /><span><strong>Pedidos centralizados</strong><small>Vários CNPJs no mesmo acesso</small></span></div>
        </div>
      </section>
      <section className="trust-strip">
        <span><BadgeCheck size={20} /> Catálogo oficial</span>
        <span><BadgeCheck size={20} /> Atendimento B2B</span>
        <span><BadgeCheck size={20} /> Histórico de pedidos</span>
      </section>
      <section className="section home-section">
        <div className="section-heading centered">
          <span className="eyebrow">Portal do representante</span>
          <h2>Mais autonomia, sem perder o atendimento próximo.</h2>
          <p>Cadastre suas empresas, escolha o CNPJ da compra e acompanhe o andamento dos pedidos em um único lugar.</p>
        </div>
        <div className="feature-grid">
          <article><span>01</span><h3>Encontre a peça</h3><p>Pesquise por aplicação, SKU ou código que você já utiliza.</p></article>
          <article><span>02</span><h3>Envie o pedido</h3><p>Selecione a empresa, o endereço de entrega e os produtos necessários.</p></article>
          <article><span>03</span><h3>Acompanhe</h3><p>Veja aprovação, produção, faturamento, expedição e entrega.</p></article>
        </div>
      </section>
    </>
  );
}
